import React from 'react';
import Navigation from "../../components/navigation";
import {Stack} from "@mui/material";
import {Outlet} from "react-router";
import {HELP_NAV_LINK} from "../../constants/helpNavLink";

const AppRealUser = () => {

    const navLinks = [
        {destination: "/icr", label: "Requirements", activePrefixes: ["/icr"]},
        {destination: "products", label: "Products"},
        {destination: "charts", label: "Charts"},
        {destination: "kb", label: "KB"},
        HELP_NAV_LINK,
    ]

    return (
        <Stack height={'100vh'} overflow={'hidden'}>
            <Navigation navLinks={navLinks} isRealUser/>
            <Stack flex={1} overflow={'auto'}>
                <Outlet/>
            </Stack>
        </Stack>
    );
};

export default AppRealUser;

